'use client'

import cn from 'clsx'
import { useLenis } from 'lenis/react'
import { useRef, useState } from 'react'
import { Link } from '~/components/link'
import { ThemeButton } from '~/components/theme-button'
import { useCartContext } from '~/integrations/shopify/cart/cart-context'
import { useCartModal } from '~/integrations/shopify/cart/modal'
import { useStore } from '~/libs/store'
import s from './footer.module.css'

export function Footer() {
  const { totalQuantity } = useCartContext()
  const { openCart } = useCartModal()
  const itemCount = totalQuantity()
  const lastScrollY = useRef(0)
  const footerRef = useRef(null)
  const lenis = useLenis()
  const isFooterFullyInView = useStore((state) => state.isFooterFullyInView)
  const [isScrollingDown, setIsScrollingDown] = useState(false)

  // Track scroll direction and update footer visibility
  useLenis((lenis) => {
    if (!lenis) return

    const currentScrollY = lenis.scroll
    setIsScrollingDown(currentScrollY > lastScrollY.current)
    lastScrollY.current = currentScrollY
  })

  return (
    <footer
      ref={footerRef}
      className={cn(
        s.footer,
        'desktop-only sticky col-span-full bottom-0 p uppercase  h-header-height z-20',
        // Only apply hidden class if we're scrolling down AND footer is not fully in view
        isScrollingDown && !isFooterFullyInView && s.hidden
      )}
    >
      <div className="dr-grid relative">
        <div
          className={cn(
            s.buttons,
            'grid grid-cols-2 items-center justify-center absolute left-0'
          )}
        >
          <ThemeButton
            square
            className="spy-6 spx-8 bg-contrast"
            theme="light"
          />
          <ThemeButton
            square
            className="spy-6 spx-8 bg-contrast"
            theme="simple"
          />
        </div>

        <Link
          className="cta cta-hover bg-contrast spx-8 spy-4 w-fit relative flex items-center col-start-5 col-span-2"
          href="https://github.com/sponsors/darkroomengineering"
        >
          Become an Open Source Sponsor
        </Link>

        {itemCount > 0 && (
          <button
            type="button"
            onClick={openCart}
            className="cta cta-hover bg-contrast spx-8 spy-4 w-fit relative flex items-center col-start-8"
          >
            CART&nbsp;
            <sup className={cn(s.itemCount, 'align-top dis')}>
              [{itemCount}]
            </sup>
          </button>
        )}

        <div
          className={cn(
            s.buttons,
            'grid grid-cols-2 items-center justify-center absolute right-0'
          )}
        >
          <ThemeButton
            square
            className="spy-6 spx-8 bg-contrast"
            theme="dark"
          />
          <ThemeButton
            square
            className="spy-6 spx-8 bg-contrast"
            theme="red"
          />
        </div>
      </div>
    </footer>
  )
}
